<app-menu></app-menu>

<div class="video-course-container" *ngIf="!isLoading && kitVideoData">
    <div class="header-video">
        <a routerLink="/minhas-compras" class="back-link">Livros</a> / <span>{{ kitVideoData.titleBook }}</span>
        <h1>{{ kitVideoData.titleBook }}</h1>
    </div>

    <div class="chapters-list">
        <div class="chapter" *ngFor="let chapter of kitVideoData.listVideoChapter">
            <h2>{{ chapter.name }}</h2>
            <p>{{ chapter.description }}</p>

            <div class="video-list">
                <div class="video-item" *ngFor="let video of chapter.listVideoStruct" (click)="openVideoPlayer(video)">
                    <div class="video-thumbnail">
                        @if(video.imageUrlFile != '' && video.imageUrlFile != null && video.imageUrlFile != undefined){
                        <img [src]="video.imageUrlFile" [alt]="video.title">
                        <span class="play-icon">&#9658;</span>
                        }
                        @else{
                        @if(isPdf(video.videoUrlFile) === true){
                        <img src="assets/images/image-pdf.png" [alt]="video.title"
                            style="display: block; width: 60%; margin: auto;">
                        }
                        @else {
                        <img src="assets/images/image-video.png" [alt]="video.title"
                            style="display: block; width: 60%; margin: auto;">
                        }

                        }

                    </div>
                    <div class="video-info">
                        <h3>{{ video.title }}</h3>
                        <p>{{video.description}}</p>
                        <div class="video-meta">
                            <!-- <span>{{ video.durationMinutes }} minutos</span> -->
                            <span class="tag-watched" *ngIf="video.isSeen">Visto</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="loading-container">
    <p>Carregando vídeos...</p>
</div>

<app-footer></app-footer>